var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.9939 25C123.442 25 146.877 25 170.313 25C173.916 25 175 26.0833 175 29.6864C175 76.5621 175 123.438 175 170.314C175 173.917 173.916 175 170.313 175C123.442 175 76.5583 175 29.6871 175C26.0835 175 25 173.917 25 170.314C25 123.438 25 76.5621 25 29.6864C25 26.0712 26.0713 25 29.6871 25C53.1227 25 76.5583 25 99.9939 25ZM32.3168 32.2547V167.684H124.757V32.2547H32.3168ZM132.207 32.2791V167.721H146.463V100.116H153.598V167.709H167.695V32.2791H132.219H132.207Z",
    fill: "#F4BF35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.878 85.728C117.854 107.48 100.189 125.13 78.4818 125.069C56.8481 125.008 39.2805 107.383 39.2683 85.7037C39.2683 63.8786 56.8846 46.387 78.8349 46.4356C100.371 46.4843 117.902 64.1221 117.878 85.728ZM78.5549 53.6052C60.8169 53.6417 46.4146 68.0416 46.4268 85.728C46.439 103.427 60.8656 117.79 78.5914 117.79C96.3294 117.79 110.732 103.39 110.719 85.6915C110.719 68.0051 96.2442 53.5808 78.5549 53.6052Z",
    fill: "#EA8632"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/Console.b1c6591f85d87703251ae1c3a3cccc87.svg";
export { ForwardRef as ReactComponent };